"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handleRadioButtonSelect = function handleRadioButtonSelect(_ref) {
  var value = _ref.value,
    isDisabled = _ref.isDisabled,
    onSelectValue = _ref.onSelectValue;
  return !isDisabled && onSelectValue(value);
};
var RadioButtonGroup = function RadioButtonGroup(_ref2) {
  var options = _ref2.options,
    selectedValue = _ref2.selectedValue,
    onSelectValue = _ref2.onSelectValue,
    isDisabled = _ref2.isDisabled,
    label = _ref2.label,
    isSmall = _ref2.isSmall,
    color = _ref2.color,
    uniqueID = _ref2.uniqueID;
  return _react.default.createElement("div", {
    className: "agillicRadioButtonGroup",
    "data-testid": uniqueID
  }, label && _react.default.createElement("label", {
    className: "displayLabel"
  }, label), options.map(function (_ref3) {
    var value = _ref3.value,
      displayName = _ref3.displayName;
    return _react.default.createElement("button", {
      key: value,
      className: (0, _classnames.default)('option', {
        selected: value === selectedValue,
        disabled: isDisabled,
        small: isSmall
      }),
      onClick: function onClick() {
        return handleRadioButtonSelect({
          value: value,
          isDisabled: isDisabled,
          onSelectValue: onSelectValue
        });
      }
    }, _react.default.createElement("div", {
      className: "circle"
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)('selection', color)
    })), _react.default.createElement("label", {
      className: "displayName"
    }, displayName));
  }));
};
RadioButtonGroup.propTypes = {
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    displayName: _propTypes.string.isRequired,
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired
  })).isRequired,
  onSelectValue: _propTypes.func.isRequired,
  selectedValue: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  isDisabled: _propTypes.bool,
  label: _propTypes.string,
  isSmall: _propTypes.bool,
  color: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  uniqueID: _propTypes.string
};
RadioButtonGroup.defaultProps = {
  color: 'grey'
};
var _default = RadioButtonGroup;
exports.default = _default;